export default __webpack_public_path__ + "images/models/272f1a158a2f09c33335a8c73099b452.glb";